import Router from "preact-router"
import { createHashHistory } from "history"
import { Room } from "./Room"
import { useRooms } from "../rooms/useRooms"

export default function RouterWrapper(props) {
    const rooms = useRooms()

    return <Router history={createHashHistory()} onChange={props.handleNewRoute}>
        {rooms.map(room => <Room {...room} path={room.path || room.name.replace(/ /g, "-").replace(/[^A-z-]/g, "")} />) }
    </Router>
}